import React, { Component } from 'react'
import { routerActions } from 'connected-react-router'
import { Switch, Route } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Header, Form, Grid, Button, Table, Message, TextArea, Segment, Confirm, Checkbox } from 'semantic-ui-react'
import moment from 'moment'
import DatePicker from '../../components/DatePicker'
import * as Facility from '../../store/Facility'
import * as Events from '../../store/Events'
import * as Venue from '../../store/Venue'
import * as geo from '../../helpers/geo'
import EventInventory from './EventInventory'
import EventCustomFields from './EventCustomFields'
import InventoryBlock from '../../components/InventoryBlock'
import Editor from '../../components/WysiwygEditor'

const distanceOptions = [
    { text: '< .1 mi.', value: 0.1 },
    { text: '< .25 mi.', value: 0.25 },
    { text: '< .5 mi.', value: 0.5 },
    { text: '< 1 mi.', value: 1 },
    { text: '< 5 mi.', value: 5 },
]

const emailFields = [
    'parkerName',
    'facilityName',
    'facilityAddress',
    'facilityCity',
    'facilityState',
    'facilityZip',
    'eventName',
    'eventAddress',
    'eventCity',
    'eventState',
    'eventSlug',
    'reservationNumber',
    'reservationBlocks',
    'reservationSpots',
    'reservationTotal',
    'reservationModificationDate',
    'eventDirections',
    'walkingDirections',
    'staffFirstName',
    'staffLastName',
    'staffTitle',
    'staffEmail',
    'staffPhone',
]

const defaultEmailTemplate =
    '<p>{{facilityName}}</p>\n' +
    '<p></p>\n' +
    "<p><a href='http://maps.google.com/?q={{encodedfacilityAddress}},+{{encodedfacilityCity}},+{{encodedfacilityState}}+{{encodedfacilityZip}}'>{{facilityAddress}}</a></p>\n" +
    "<p><a href='http://maps.google.com/?q={{encodedfacilityAddress}},+{{encodedfacilityCity}},+{{encodedfacilityState}}+{{encodedfacilityZip}}'>{{facilityCity}}, {{facilityState}} {{facilityZip}}</a></p>\n" +
    '<p></p>\n' +
    '<p></p>\n' +
    '<p>{{parkerName}},</p>\n' +
    '<p></p>\n' +
    '<p>Thank you for your parking reservation for the {{eventName}} event in {{eventCity}}, {{eventState}}. Below you will find your parking reservation information. </p>\n' +
    "<p style='padding-left: 30px;'><strong>Reservation Number:</strong> <a href='https://reservations.denisonparking.com/{{eventSlug}}/{{reservationNumber}}/confirmation'>{{reservationNumber}}</a></p>\n" +
    "<p style='padding-left: 30px;'><strong>Reservation Information:</strong> {{reservationBlocks}}</p>\n" +
    "<p style='padding-left: 30px;'><strong>Parking spot quantity reserved:</strong> {{reservationSpots}}</p>\n" +
    "<p style='padding-left: 30px;'><strong>Total charged:</strong> {{reservationTotal}}</p>\n" +
    "<p>To update or cancel this reservation, please contact the garage manager. Parking requests can be modified up to {{reservationModificationDate}}. If you have questions, please visit our <a href='https://s3.us-east-2.amazonaws.com/denisonparking-static/FAQ.pdf'>FAQ page</a>.</p>\n" +
    '<p></p>\n' +
    '<p></p>\n' +
    '<p><strong>What to do upon arrival:</strong></p>\n' +
    '<p>{{eventDirections}}</p>\n' +
    '<p></p>\n' +
    '<p></p>\n' +
    '<p><strong>Walking directions from the facility to the event:</strong></p>\n' +
    '<p>{{walkingDirections}}</p>\n' +
    '<p></p>\n' +
    '<p></p>\n' +
    '<p>{{staffFirstName}} {{staffLastName}}</p>\n' +
    '<p>{{staffTitle}}</p>\n' +
    '<p>{{facilityName}}</p>\n' +
    '<p>E. {{staffEmail}}</p>\n' +
    '<p>P. {{staffPhone}}</p>'
class EditEvent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: null,
            distanceFilter: 0.1,
            emailTemplate: null,
            showDeleteConfirmation: false,
        }
        this.onGarageSelected = this.onGarageSelected.bind(this)
        this.onChange = this.onChange.bind(this)
        this.onChangeCheckbox = this.onChangeCheckbox.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.onAddBlock = this.onAddBlock.bind(this)
        this.onBlockChange = this.onBlockChange.bind(this)
        this.onDistanceChange = this.onDistanceChange.bind(this)
        this.filter = this.filter.bind(this)
        this.onEditorChange = this.onEditorChange.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.onCancelDelete = this.onCancelDelete.bind(this)
        this.onConfirmDelete = this.onConfirmDelete.bind(this)
        this.onPublish = this.onPublish.bind(this)
        console.log(this.props.event)
    }

    onChange(e, { name, value }) {
        const { event, actions } = this.props
        let newProps = { [name]: value }
        if (name === 'name') {
            newProps = { ...newProps, slug: value.replace(/ /g, '').toLowerCase() }
        }
        actions.updateEditEvent({ ...event, ...newProps })
    }

    onChangeCheckbox(e, { name, checked }) {
        const { event, actions } = this.props
        let newProps = { [name]: checked }
        actions.updateEditEvent({ ...event, ...newProps })
    }

    onDistanceChange(e, { name, value }) {
        console.log(value)
        this.setState({ distanceFilter: value })
    }

    onAddBlock(e) {
        const { actions, event } = this.props
        e.preventDefault()
        actions.addEditBlock(event)
    }

    onBlockChange(e, block) {
        const { actions, event } = this.props
        actions.updateEditBlock(event, block)
    }

    async onPublish(e) {
        const { event, actions } = this.props
        await actions.publishEvent({ ...event })
    }

    async onSubmit(e) {
        const { event, actions } = this.props
        const { emailTemplate } = this.state
        try {
            const { blocks } = event
            const newBlocks = [
                ...blocks.map((b) => {
                    const newB = { ...b }
                    if (newB.id.length !== 36) {
                        delete newB.id
                    }
                    return newB
                }),
            ]
            const template = emailTemplate || event.reservationEmailTemplate || defaultEmailTemplate
            var result = await actions.updateEvent({ ...event, blocks: newBlocks, reservationEmailTemplate: template })
            actions.replace(`/admin/event/${result.response.id}/inventory`)
        } catch (error) {
            this.setState({ error: error.message })
        }
    }

    onGarageSelected(id) {
        // const id = e.target.dataset.facility;
        let { event, actions } = this.props
        if (event.participatingFacilities.findIndex((x) => x.facilityId === id) !== -1) {
            event.participatingFacilities = event.participatingFacilities.filter((x) => x.facilityId !== id)
        } else {
            event.participatingFacilities = [...event.participatingFacilities, { facilityId: id }]
        }
        actions.updateEditEvent({ ...event })
    }

    onEditorChange(html) {
        this.setState({ emailTemplate: html })
    }

    async onDelete(e) {
        e.preventDefault()
        const { event, actions } = this.props
        try {
            await actions.deleteEvent(event)
            actions.replace('/admin')
            this.setState({ showDeleteConfirmation: false })
        } catch (error) {
            this.setState({ error: error.message, showDeleteConfirmation: false })
            window.scrollTo(0, 0)
        }
    }

    onConfirmDelete(e) {
        e.preventDefault()
        this.setState({ showDeleteConfirmation: true })
    }

    onCancelDelete(e) {
        e.preventDefault()
        this.setState({ showDeleteConfirmation: false })
    }

    filter(facility) {
        const { distanceFilter } = this.state
        const { event, venues } = this.props
        if (event) {
            const venue = venues[event.venueId]
            if (venue) {
                const distance = geo.distance(parseFloat(venue.lat), parseFloat(venue.lng), parseFloat(facility.lat), parseFloat(facility.lng))
                console.log(distance)
                return distance < distanceFilter
            }
        }
        return true
    }

    render() {
        const { error, emailTemplate, showDeleteConfirmation } = this.state
        const { facilities, event, venues } = this.props

        const sortBlocks = (a, b) => moment.utc(a.startDate) - moment.utc(b.startDate) || moment.utc(b.endDate) - moment.utc(a.endDate)

        return (
            <Switch>
                <Route path="/admin/event/:eventId/inventory" component={EventInventory} />
                <Route path="/admin/event/:eventId/customfields" component={EventCustomFields} />
                {event ? (
                    <div className="event">
                        <Confirm
                            header="Delete Event"
                            confirmButton="Delete"
                            open={showDeleteConfirmation}
                            onCancel={this.onCancelDelete}
                            onConfirm={this.onDelete}
                            content="Are you sure you want to delete this event?"
                        />

                        <Grid columns="equal">
                            <Grid.Column>
                                <Header as="h1" content="Edit Event" />
                            </Grid.Column>
                            <Grid.Column>
                                <Checkbox name="isPublic" label="IsPublic" checked={event.isPublic} onChange={this.onChangeCheckbox} />
                                <Button
                                    style={{ float: 'right' }}
                                    content={event.isPublished ? 'Published' : 'Publish'}
                                    disabled={event.isPublished}
                                    primary
                                    onClick={this.onPublish}
                                />
                            </Grid.Column>
                        </Grid>

                        <Form onSubmit={this.onSubmit} error>
                            {error ? <Message error content={error} /> : error}
                            <Grid>
                                <Grid.Column computer={8} tablet={16} mobile={16}>
                                    <Form.Field>
                                        <label>{`Event URL: https://reservations.denisonparking.com/${event.slug}`}</label>
                                    </Form.Field>
                                    <Form.Input name="name" label="Event Name" placeholder="Event Name" value={event.name} onChange={this.onChange} />
                                    <Form.Select
                                        name="venueId"
                                        label="Event Venue"
                                        placeholder="Event Venue"
                                        value={event.venueId}
                                        options={Object.values(venues).map((s, index) => ({ text: s.name, value: s.id }))}
                                        onChange={this.onChange}
                                    />
                                    <Form.Input name="contactName" label="Contact Person" placeholder="Contact Person" value={event.contactName} onChange={this.onChange} />
                                    <Form.Input name="contactEmail" label="Contact Email" placeholder="Contact Email" value={event.contactEmail} onChange={this.onChange} />
                                    <Form.Input name="contactPhone" label="Contact Phone" placeholder="Contact Phone" value={event.contactPhone} onChange={this.onChange} />
                                    {/* <Form.Group> */}
                                    <Form.Field>
                                        <label>From</label>
                                        <DatePicker
                                            name="start"
                                            placeholderText="From"
                                            selected={moment.utc(event.start) || null}
                                            onChange={this.onChange}
                                            showYearDropdown
                                            showMonthDropdown
                                            scrollableYearDropdown
                                            timeIntervals={15}
                                            showTimeSelect
                                            dateFormat="MMMM Do YYYY, h:mm a"
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>To</label>
                                        <DatePicker
                                            name="finish"
                                            placeholderText="To"
                                            selected={moment.utc(event.finish) || null}
                                            onChange={this.onChange}
                                            showYearDropdown
                                            showMonthDropdown
                                            scrollableYearDropdown
                                            timeIntervals={15}
                                            showTimeSelect
                                            dateFormat="MMMM Do YYYY, h:mm a"
                                        />
                                    </Form.Field>
                                    {/* </Form.Group> */}
                                    <Form.Field>
                                        <label>What to do when they arrive?</label>
                                        <TextArea placeholder="Directions" name="directions" value={event.directions} onChange={this.onChange} />
                                    </Form.Field>
                                </Grid.Column>
                                <Grid.Column computer={8} tablet={16} mobile={16}>
                                    <Table>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell textAlign="center">Participating Facilities</Table.HeaderCell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.HeaderCell>
                                                    <Form.Select label="Distance" defaultValue={0.1} selection options={distanceOptions} onChange={this.onDistanceChange} />
                                                </Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            {Object.values(facilities)
                                                .filter(this.filter)
                                                .map((f, index) => (
                                                    <Table.Row
                                                        key={index}
                                                        onClick={() => this.onGarageSelected(f.id)}
                                                        className={event.participatingFacilities.findIndex((x) => x.facilityId === f.id) !== -1 ? 'garage selected' : ''}
                                                    >
                                                        <Table.Cell>
                                                            <div>{f.name}</div>
                                                        </Table.Cell>
                                                    </Table.Row>
                                                ))}
                                        </Table.Body>
                                        <Table.Footer>
                                            <Table.HeaderCell></Table.HeaderCell>
                                        </Table.Footer>
                                    </Table>
                                    <Segment>
                                        <Header as="h3" content="Reservation Blocks" />
                                        <p>
                                            Reservation blocks are the time periods a parking spot may be reserved, with a rate. This may be a single date or may span consecutive
                                            days. Inventory will be allotted and tracked for each block.
                                        </p>
                                        <div>
                                            {event.blocks.sort(sortBlocks).map((b, idx) => (
                                                <InventoryBlock key={idx} block={b} onChange={this.onBlockChange} />
                                            ))}
                                        </div>
                                        <Button content="Add Block" type="button" onClick={this.onAddBlock} />
                                    </Segment>
                                </Grid.Column>
                            </Grid>
                            <Header as="h3" content="Email Template" />
                            <Editor onChange={this.onEditorChange} fields={emailFields} template={emailTemplate || event.reservationEmailTemplate || defaultEmailTemplate} />
                            <Button primary content="Save and Next" />
                            <Button negative floated="right" content="Delete Event" type="button" onClick={this.onConfirmDelete} />
                        </Form>
                    </div>
                ) : null}
            </Switch>
        )
    }
}

EditEvent.propTypes = {}

const mapStateToProps = (state, ownProps) => {
    return {
        facilities: Facility.selector(state).facilities,
        event: Events.selector(state).events[ownProps.match.params.eventId],
        venues: Venue.selector(state).venue,
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(Facility.actionCreators, dispatch),
        ...bindActionCreators(Events.actionCreators, dispatch),
        ...bindActionCreators(routerActions, dispatch),
    },
})

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(EditEvent)
)
